/**
 * Normalizes SVG markup or file URLs for use in <img src>.
 * API fields often return raw "<svg>...</svg>" strings, which img cannot load directly.
 */
export function toImageSrc(value) {
    if (!value) return "";

    const trimmed = String(value).trim();

    if (
        trimmed.startsWith("data:") ||
        trimmed.startsWith("/") ||
        trimmed.startsWith("http://") ||
        trimmed.startsWith("https://")
    ) {
        return trimmed;
    }

    if (trimmed.startsWith("<svg")) {
        return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(trimmed)}`;
    }

    return trimmed;
}
